window.jQuery = window.$ = require('jquery');

const selectize = require('selectize');

const jquery_validation = require('jquery-validation');

const slick_slider = require('slick-carousel');

jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    }
});

/**
 * reload page on back history (01/06/2021 update)
 */
// window.onpopstate = function(){
//   location.reload()
// };


jQuery(document).ready(function($){


  /*=======================================
  MENU LINK CLASS ACTIVE FOR USER
  =======================================*/
  let _aName = '';
  switch (window.location.pathname) {
    case '/shop':
      let t = new URLSearchParams(window.location.search).get('t');
      _aName =  ['general', 'outlet', 'new-in'].indexOf(t) > -1 ? t : 'general';
    break;
    case '/promotions':
      _aName = 'promotions-list';
    break;
  }
  $('#navigation li a[name="'+_aName+'"]').addClass('active red');


  /*==========================
  Set Token
  ==========================*/

  $.token = document.querySelector('meta[name="csrf-token"]').content;

  /*=======================================
  MENU HEADER RESPONSIVE
  =======================================*/
  $(document).on('click', '#ham', function(e){


  let menu_secondary = '#app-menu .menu-content .bar.bottom-bar';
  if ($("#ham").hasClass("open")) {
    // $("#primary-menu").css( "opacity", "0");
    // $("#container-primary-menu").animate( {opacity: "0"}, 400, "linear", function(){
    //   $("#container-primary-menu").css( "left", "-105%");
    // });
    $(menu_secondary).toggleClass('active');
    $("#ham").toggleClass("open");
  }
  else{
    // $("#container-primary-menu").css( "left", "0");
    // $("#container-primary-menu").animate( {opacity: "1"}, 200, "linear", function(){
    //   $("#primary-menu").animate( {opacity: "1"}, 100, "swing", function(){});
    // });
    $(menu_secondary).toggleClass('active');
    $("#ham").toggleClass("open");
    $('span.close-menu-tool').trigger('click');
  }

    /*   CLICK in site-content end site-footer   */
  // $(".site-content, .site-footer, #primary-menu a[href=#contacts]").click(function(){
  //
  //   if ($("#ham").hasClass("open")) {
  //       $("#container-primary-menu").animate( {left: "-105%"}, 400, "linear", function(){
  //       $("#primary-menu").css("opacity", "0");
  //     });
  //     $("#ham").toggleClass("open");
  //   } });

  });

  /*=======================================
    Click link sub menu
  =======================================*/
  const PARENT_SUB_MENU = '.parent-submenu';
  const SUB_MENU = '.handle-submenu';
  
  $(document).on('click', PARENT_SUB_MENU, function(){
    $(this).find(SUB_MENU).toggleClass('none');
  })

  $(document).on('mouseenter', PARENT_SUB_MENU, function(){
    if ($(this).find(SUB_MENU).hasClass('none')) {
      $(this).find(SUB_MENU).removeClass('none');
    }
    $(document).on('mouseleave', PARENT_SUB_MENU, function(){
      console.log("MOUSE OUT ", new Date())
      $(this).find(SUB_MENU).addClass('none');
    })
  })


  

  /*=======================================
  PREVENT MULTI SUBMIT
  =======================================*/
  $(document).on('click', 'button.loading', function(e){
    e.preventDefault();
  })

  /*=======================================
  SWITCH LIST ITEMS LAYOUT
  N.B SVG animation, not .png
  =======================================*/
  $(document).on('click', 'svg.switch-layout', function(){

    var parent = $(this).closest('.grid-layout');
    parent.find('svg.switch-layout').each(function(){
      $(this).removeClass('selected');
    })
    $(this).addClass('selected');

    var layout = $(this).data('layout');
    var data_element = $(this).data('element');

    var flex = $(document).find('div.flex-layout[data-element="'+data_element+'"]');

    flex.attr('data-layout', layout);

  })

  /*=======================================
  APPEND APP MESSAGES
  =======================================*/
  $.extend({

    bonin_app_message: function(options){

      var settings = $.extend({
          message: '',
          type: '',
          manual_remove: false
      }, options );

      if( $(document).find('.app-message').length ){
        $(document).find('.app-message').remove();
      }

      var manual_remove_class = ( settings.manual_remove ? 'manual' : 'automatic' );

      $('.app-message-wrapper').append('<div class="app-message '+ settings.type + " " + manual_remove_class + '"><span class="close-app-message">&times</span>'+ settings.message +'</div>');

    }

  })

  $(document).on('click', 'span.close-app-message, .app-message-wrapper .app-message button', function(){

    if( $('.app-message').length ){

      if( $('.app-message').hasClass('shown') ){
        $('.app-message').removeClass('shown');
      }

      setTimeout(function(){
        $('.app-message').remove();
      }, 500);

    }

  })

  // Mutations observed for app messages
  var message_target = $('.app-message-wrapper')[0];
  var message_config = {
    attributes: false,
    childList: true,
    subtree: true
  };

  var message_callback = function(mutationsList, observer){

    for(let mutation of mutationsList){

      if( mutation.addedNodes[0] && mutation.addedNodes[0].classList.contains('app-message') ){

        // show message
        setTimeout(function(list){

          list.add('shown');

        }, 50, mutation.addedNodes[0].classList)

        var element = $(mutation.addedNodes[0]);;

        // hide message automatically (if message is automatic removable)
        if( mutation.addedNodes[0].classList.contains('automatic') ){

          setTimeout(function(element){

            if( element.length ){

              element.removeClass('shown');
              setTimeout(function(element){
                element.remove();
              }, 500,element);

            }

          }, 5000, element)

        }

      }

    }

  }

  var observer = new MutationObserver(message_callback);
  observer.observe(message_target, message_config);

  /*=======================================
  SCROLL TOP
  =======================================*/
  $.extend({

    scroll_up: function(timing){

      $('html, body').animate({
        scrollTop: 0
      }, timing);

    }

  })


  /*=======================================
  APPEND PAGE LAYER
  =======================================*/
  $.extend({

    bonin_page_float: function(options){

      var settings = $.extend({
          content: '',
          callback: ''
      }, options );


      if( $('.app-layer').length ){
        $('.app-layer').remove();
      }

      $('#app').append('<div class="app-layer">'+settings.content+'</div>');

      // callback function
      if( settings.callback != '' ){
        settings.callback.call(this);
      }

    }

  }) // $.extend


  $.fn.bonin_page_float = function( options ){

    var settings = $.extend({
        content: '',
        callback: ''
    }, options );

    if( $('.app-layer').length ){
      $('.app-layer').remove();
    }

    $('#app').append('<div class="app-layer">'+settings.content+'</div>');

    // callback function
    if( settings.callback != '' ){
      settings.callback.call(this);
    }

  }

  $(document).on('click', '.app-layer span.close, #app-float span.close', function(){
    if( $('.app-layer').length ){
        $('.app-layer').remove();
    }
  })

  /*=======================================
  APPEND FORM MESSAGES
  =======================================*/
  $.fn.bonin_form_message = function( options ){

    var settings = $.extend({
        type: 'error',
        message: 'Errore nella compilazione del form'
    }, options );

    // check for previous messages
    this.find('p.form-message').remove();

    // append new message
    this.append('<p class="form-message '+settings.type+'">'+settings.message+'</p>');

  }

  /*=======================================
  CUSTOM CHECKBOXES
  =======================================*/
  $(document).on('click', 'p.checkbox label', function(e){

    var input = $(this).find('input[type="checkbox"]');

    if( input.is(':checked') ){
      input.prop('checked', false);
    } else{
      input.prop('checked', true);
    }

  })

  /*=======================================
  CUSTOM RADIO INPUT
  =======================================*/
  $(document).on('click', '.input-radio', function(e){

    var input = $(this).find('input[type="radio"]');
    $('input[type="radio"][name="' + input.attr('name') + '"]').prop('checked', false).parents('.input-radio').removeClass('radio-selected');
    input.prop('checked', true);
    $(this).addClass('radio-selected');
  })

  /*=======================================
  LOGOUT
  =======================================*/
  $(document).on('click', '#logout', function(){

    var token = $(this).data('token');

    $.ajax({

      method: 'post',
      url: '/logout',
      headers: {
        'X-CSRF-TOKEN': token
      },
      dataType: 'json',
      beforeSend: function(){
        $('body').addClass('loading');
      },
      error: function(xhr){
        $('body').removeClass('loading');
        $.bonin_app_message({
          type: 'error',
          message: 'Impossibile effettuare il logout'
        });
      },
      success: function(data){
        window.location.replace(data.url);
      }

    }) // ajax.call

  })



  /*=======================================
  MENU ELEMENTS ANIMATIONS
  =======================================*/
  $(document).on('click', '#notification-icon', function(){

    if( !$('#notification-bar').hasClass('active') ){
      $(document).menu_open_tool({tool: 'notification-bar'});
    } else{
      $(document).close_open_tool({tool: 'notification-bar'});
    }

  })

  $(document).on('click', '#user-sub', function(){
    if( !$('#mini-personal').hasClass('active') ){
       $(document).menu_open_tool({tool: 'mini-personal'});
     } else {
       $(document).close_open_tool({tool: 'mini-personal'});
     }
  })

  $(document).on('click', '#cart-icon', function(){
    if( !$('#mini-cart').hasClass('active') ) {
      $(document).menu_open_tool({tool: 'mini-cart'});
    } else {
      $(document).close_open_tool({tool: 'mini-cart'});
    }

  })

  $(document).on('click', '#search-icon', function(){

    if( !$('#global-search-mobile').hasClass('active') ) {
      $(document).menu_open_tool({tool: 'global-search-mobile'});
    } else {
      $(document).close_open_tool({tool: 'global-search-mobile'});
    }


  })

  /*=======================================
  CLOSE MENU TOOL
  =======================================*/
  // cross symbol
  $(document).on('click', 'span.close-menu-tool', function(){

    $(this).parent('.menu-tool').removeClass('active');

    if( $('#page-content').find('.page-layer').length ){
      $('#page-content').find('.page-layer').remove();
    }

  })

  // page layer
  $(document).on('click', '.page-layer', function(){

    $('.menu-tool').each(function(){
      $(this).removeClass('active');
    })
    $('.page-layer').remove();

  })

  /*=======================================
  OPEN MENU TOOL
  =======================================*/
  $.fn.menu_open_tool = function(options){

    var settings = $.extend({
        tool: '',
    }, options );

    $('body').find('.menu-tool').each(function(){
      $(this).removeClass('active');
    });

    if($('#ham').hasClass('open')) {
      $('#ham').trigger('click');
    }

    switch (settings.tool) {

      case 'mini-cart':
      $('#mini-cart').addClass('active');

      break;

      case 'notification-bar':
      $('#notification-bar').addClass('active');

      break;

      case 'mini-personal':
      $('#mini-personal').addClass('active');

      break;

      case 'global-search-mobile':
      $('#global-search-mobile').addClass('active');
      break;
    }

    if( !$('#page-content').find('.page-layer').length ){
      $('#page-content').append('<div class="page-layer"></div>')
    }

  }

  /*=======================================
  CLOSE MENU TOOL
  =======================================*/
  $.fn.close_open_tool = function(options){

    var settings = $.extend({
        tool: '',
    }, options );

    var element = '';

    switch (settings.tool) {

      case 'mini-cart':
        element = $('#mini-cart');
      break;

      case 'mini-personal':
        element = $('#mini-personal');
      break;

      case 'notification-bar':

        element = $('#notification-bar');
      break;

      case 'global-search-mobile':

        element = $('#global-search-mobile');
      break;

    }

    if( element.hasClass('active') ){
      element.removeClass('active');
    }

    if( $('#page-content').find('.page-layer').length ){
      $('#page-content').find('.page-layer').remove();
    }

  }

  /*===================================
  TONGUE SELECTORS
  ===================================*/
  $(document).on('click', '.tongue_selector .tongue', function(){

    $(this).parent('.tongue_selector').find('.tongue').each(function(){
      $(this).removeClass('active');
    });

    $(this).addClass('active');
    var selector_ref = $(this).data('ref');

    $('body').find('.tongue_section').each(function(){

      var section_ref = $(this).data('ref');

      if( section_ref == selector_ref ){
        $(this).addClass('active');
      } else{
        $(this).removeClass('active');
      }

    })

  })


  /*=======================================
  CONFIRM ACTION PLUGIN
  =======================================*/
  $.fn.bonin_confirm_action = function(options){

      var that = this;

      var settings = $.extend({
          title: '',
          message: '',
          confirm_text: 'conferma',
          close_text: 'chiudi',
          callback: '',
      }, options );

      var template = `
        <div class="app-layer">
          <div class="confirm_action">
            <h2 class="mt-0">{{title}}</h2>
            <p class="mt-0">{{text}}</p>
            <div class="actions">
              <button class="confirm_action" name="confirm_action">{{confirm_text}}</button>
              <button class="close_action" name="close_action">{{close_text}}</button>
            </div>
          </div>
        </div>
      `;

      template = template.replace('{{title}}', settings.title);
      template = template.replace('{{text}}', settings.message);
      template = template.replace('{{confirm_text}}', settings.confirm_text);
      template = template.replace('{{close_text}}', settings.close_text);

      if( this.find('.app-layer').length ){
        this.find('.app-layer').remove();
      }
      this.append(template);

      // action buttons
      function close_action(){

        $('#app').find('.app-layer').remove();

      }

      function confirm_action(){

        if ( $.isFunction( settings.callback ) ){
          settings.callback.call(this);
          $('#app').find('.app-layer').remove();
        }

      }

      this.find('button[name="close_action"]').click( close_action );
      this.find('button[name="confirm_action"]').click( confirm_action );

    }

  /*=======================================
  CLOSE APP FLOAT WITH ESC BUTTON
  =======================================*/
  $(document).on('keyup',function(evt){

    if (evt.keyCode == 27 && $('#app').find('.app-layer').length ) {
      $('#app').find('.app-layer').remove();
    }

  })

  /*=======================================
  CONTACTS ANCORE EFFECT
  =======================================*/
  $(document).on('click', 'a[href="#contacts"]', function(){

    var element_height = $('a[name="contacts"]').offset().top;
    $('html, body').animate({
      scrollTop: element_height
    }, 300);

  }) // end of function

  /*==============================================================
  BONIN MEDIALIBRARY
  ==============================================================*/
  $.extend({

    bonin_media: function(options){

      var settings = $.extend({
        element: null,
        collection: null,
        multi: false,
        preview_el: null,
        input_el: null,
        src_el: null,
        event_name: 'media_library_selection', // valore default nome evento
      }, options );


      // get html template
      $.ajax({

        method: 'get',
        url: '/admin/media',
        headers: {
          headers: {
            'X-CSRF-TOKEN': $('#app').find('input[name="global_token"]').val()
          },
        },
        data: {
          element: settings.element,
          collection: settings.collection,
          preview_el: settings.preview_el,
          input_el: settings.input_el,
          src_el: settings.src_el,
          event_name: settings.event_name,
        },
        dataType: 'json',
        beforeSend: function(){
          $('#app').append('<div class="app-layer loading"></div>')
        },
        error: function(xhr){

          console.log(xhr);
          alert('Non è possibile accedere alla libreria dei media, si prega di riprovare più tardi');

        },
        success: function(data){

          // print html template on page
          $.bonin_page_float({
            content: data.html
          });

        } // ajax.success

      }) // ajax.call

    } // end of function

  }) // $.extend

  /*=======================================
  LOAD MORE MEDIA
  =======================================*/
  $(document).on('click', 'button#load_more_media', function(){

    var container = $(this).closest('div.load_more');
    var button = $(this);
    var step = ( button.attr('data-step') ? button.attr('data-step') : null );

    $.ajax({
      method: 'get',
      url: '/admin/media/load?page=' + step,
      headers: {
        'X-CSRF-TOKEN': $('#app').find('input[name="global_token"]').val()
      },
      data: {
        step: step
      },
      dataType: '',
      beforeSend: function(){
        container.addClass('loading');
      },
      complete: function(){
        container.removeClass('loading');
      },
      error: function(xhr){

        console.log(xhr);
        $.bonin_app_message({
          type: 'error',
          message: 'Imposibile caricare i media'
        });

      },
      success: function(data){

        console.log(data);

        // append new data
       if( data.items ){

         $.each( data.items, function(key, value){

           $('#medialibrary-list').find('ul').append(value);

         })

       }

       // update step info
       if( data.info ){

         if( data.info.current_page < data.info.last_page ){

           var next_step = button.data('step') + 1;
           button.attr('data-step', next_step);

         } else{

           container.remove();

         }

       }

      }
    })

  }) // end of function

  /*=======================================
  THUMB SELECTOR (single selection)
  =======================================*/
  $(document).on('click', '#medialibrary-list div.thumb', function(){

    // remove other selection
    $('#medialibrary-list').find('div.thumb').each(function(){
      $(this).removeClass('selected');
    })

    // remove banner-to-delete elements
    if( $('#medialibrary-list').find('div.remove-media').length ){
      $('#medialibrary-list').find('div.remove-media').each(function(){
        $(this).remove();
      })
    }

    // add selection
    $(this).addClass('selected');

    // assign hidden inputs value
    $('.medialibrary').find( 'input[name="media_selected"]').val($(this).data('id') );
    $('.medialibrary').find( 'input[name="src_selected"]').val($(this).data('src') );
    let name_media = ($(this).data('src') || '/').split('/').pop()
    $('.medialibrary').find( 'input[name="name_media_selected"]').val(name_media);
  })

  /*=======================================
  SELECT MEDIA
  ...(only single selection)
  =======================================*/
  $(document).on('click', '#choose_media', function(e){

    e.preventDefault();

    var id = $('.medialibrary').find( 'input[name="media_selected"]').val();
    var src = $('.medialibrary').find( 'input[name="src_selected"]').val();
    var name = $('.medialibrary').find( 'input[name="name_media_selected"]').val();
    var element = $('.medialibrary').find( 'input[name="element"]').val();
    var event_name = $('.medialibrary').find( 'input[name="event_name"]').val();

    var media_list = $(document).find(element).find('.media-list');

    if( id == '' || src == '' ){
      alert('Nessun file selezionato');
      return false;
    }

    // set input and src element
    $(document).find(element).find('input[name="media_id"]').val(id);
    $(document).find(element).find('input[name="media_src"]').val(src);
    $(document).find(element).find('input[name="media_name"]').val(name);

    // remove placeholder with img
    if( $(document).find(element).find('div.media.placeholder').length ){

      $(document).find(element).find('div.media.placeholder').remove();

      // set new preview image
      var template = `
      <div class="media media-1">
        <img src="{{src}}" class="media-preview {{preview_class}} name="media_preview"">
        <button type="button" name="close_media_preview">rimuovi</button>
      </div>
      `;

      template = template.replace('{{src}}', src);
      template = template.replace('{{preview_class}}', media_list.data('class'));
      media_list.append(template);


    } else{

      $(document).find(element).find('div.media').find('img').attr('src', src);

    }


    $('.app-layer').find('span.close').trigger('click');
    if (event_name.trim() == '')
      event_name = 'media_library_selection';
    $(document).trigger(event_name, {
      media_id: id,
      media_src: src,
      element: element
    });


  })

  /*=======================================
  DELETE MEDIA FROM MEDIA PICKER
  =======================================*/
  $(document).on('click', 'button[name="close_media_preview"]', function(){

    var parent = $(this).closest('div.bonin-media-picker');
    var item_list = parent.find('div.media-list');
    var item = $(this).closest('div.media');

    // remove input value
    parent.find('input[name="media_id"]').val('');

    // remove item from preview list
    item.remove();

    // add placeholder pic if no other media are set
    if( !item_list.find('media').length ){

      var placeholder = `
      <div class="media placeholder">
        <img name="media-preview"
          class="media-preview placeholder"
          src="{{placeholder_src}}">
      </div>
      `;

      var placeholder = placeholder.replace('{{placeholder_src}}', item_list.data('placeholder'))

      item_list.append( placeholder );

      $(document).trigger('media_picker_item_removed');

    }

    parent.trigger('media_deleted');

  })

  /*=======================================
  UPLOAD PREVIEW
  =======================================*/
  $(document).on('change', '#medialibrary_upload', function(e){

    // reset preview
    $('#upload_preview').empty();

    // print new previews
    $.each( e.target.files, function(key, value){

      console.log(e.target.files);

      if( value.type == 'image/png' || value.type == 'image/jpeg' ){
        var url = URL.createObjectURL(value);
      } else{
        var url = $('form.medialibrary_add_media').data('placeholder');
      }
      // var url = URL.createObjectURL(value);
      var template = `
      <div class="item">
        <div class="wrapper"
          style="background: url('{{url}}') no-repeat center/cover">
        </div>
      </div>
      `;
      template = template.replace('{{url}}', url);

      $('#upload_preview').append(template);

    })


  })

  /*=======================================
  UPLOAD NEW MEDIA
  =======================================*/
  $(document).on('click', '#upload_media', function(e){

    e.preventDefault();

    var form = $('form.medialibrary_add_media');
    var button = $(this);
    var file_input = form.find('input[type="file"]');
    var collection = $('#medialibrary-list').data('collection');

    console.log(new FormData(form[0]));
    $.ajax({

      method: 'post',
      url: '/admin/media',
      headers: {
        'X-CSRF-TOKEN': $('input[name="global_token"]').val()
      },
      data: new FormData(form[0]),
      dataType: 'json',
      contentType: false,
      processData: false,
      beforeSend: function(){
        button.addClass('loading');
      },
      complete: function(){
        button.removeClass('loading');
      },
      error: function(xhr){

        console.log(xhr);
        if( xhr.status == 422 ){

          $.bonin_app_message({
            type: 'error',
            message: 'I file non rispettano i requisiti per l\'upload'
          })

        } else{

          $.bonin_app_message({
            type: 'error',
            message: 'Si è verificato un errore durante l\'upload'
          })

        }

      },
      success: function(data){

        console.log(data);

        // replace media list
        if( data.html ){
          $('#medialibrary-list').replaceWith(data.html);
        }

        // clean form
        file_input.val('');
        $('#upload_preview').empty();

        // bonin app message
        $.bonin_app_message({
          type: 'success',
          message: 'File caricati correttamente'
        })

      } // ajax.success

    }) // ajax.call

  }) // click

  /*=======================================
  DELETE MEDIA FROM MEDIA LIBRARY (CONFIRM)
  =======================================*/
  $(document).on('click', 'li.media-item button[name="remove_media_from_medialibrary"]', function(e){

    e.preventDefault();

    var parent = $(this).closest('li.media-item');
    var template = `
      <div class="remove-media">
        <h4 class="mt-0">Rimovere?</h4>
        <div class="actions">
          <button class="delete">SI</button>
          <button class="close">NO</button>
        </div>
      </div>
    `;

    parent.append(template);

  })

  $(document).on('click', 'div.remove-media button.close', function(){

    $(this).closest('div.remove-media').remove();

  })

  /*=======================================
  DELETE MEDIA FROM MEDIA LIBRARY (ACTION)
  =======================================*/

  $(document).on('click', 'div.remove-media button.delete', function(){

    var parent = $(this).closest('li.media-item');
    var media_id = parent.data('id');
    var token = $(document).find('input[name="global_token"]').val();

    $.ajax({

      method: 'post',
      url: '/admin/media/remove',
      headers: {
        'X-CSRF-TOKEN': token
      },
      data: {
        media_id: media_id
      },
      dataType: 'json',
      beforeSend: function(){
        parent.addClass('loading');
      },
      complete: function(){
        parent.removeClass('loading');
      },
      error: function(xhr){

        console.log(xhr);
        alert('Impossibile eliminare il file');

      },
      success: function(data){

        console.log(data);

        if( data.fragments ){

          parent.animate({
            opacity: 0
          }, 200, function(){
            parent.remove();
          });

        }

      } // ajax.success

    }) // ajax.call

  }) // button.click

  /*==============================================================
  END OF BONIN MEDIA LIBRARY
  ==============================================================*/

  /*=======================================
  SHOW-HIDDEN PASSWORD CHARACTERS
  =======================================*/
  $(document).on('click', 'div.password-input svg', function(){

    $(this).toggleClass('show');
    var input = $(this).closest('div.password-input').find('input');

    if( input.prop('type') == 'password' ){
      input.prop('type', 'text');
    } else{
      input.prop('type', 'password')
    }

  })


}); // document.ready
